import { Dialog, DialogTitle, DialogContent, DialogActions, Button, MobileStepper, makeStyles, useTheme, IconButton, CircularProgress } from "@material-ui/core";
import { FC, ReactNode, useEffect, useState } from "react";
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { termoDeAceiteProvider } from "src/providers/cadastros/TermosAceiteProvider";
import { ITermoAceite, ResponseTermoAceiteFinanceiras, ResponseTermoAceitePedido } from "src/providers/cadastros/TermosAceiteProvider/types";
import { FinanceiraType, TTIPO_TERMO_ACEITE } from "src/types";
import { TermoAceite } from "./TermoAceite";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { MdClose, MdOutlineErrorOutline } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { LocalStorage } from "src/framework/commons";
import { CacheType } from "src/store/global.store";
import "./styles.scss";

const TIPO_TERMO_PEDIDO: any = {
    "pedido": 0,
    "faturamento": 1,
}
interface ConfirmData {
    termos: ITermoAceite[],
    data_previsao_faturamento?: string,
    estabelecimento?: number,
}

interface TermosAceiteList {
    [grupo: number]: ITermoAceite[];
}

interface TermosDeAceiteProperties {
    open: boolean;
    tipo: TTIPO_TERMO_ACEITE;
    codigoPedido: string;
    termosFinancieras?: ResponseTermoAceiteFinanceiras[] | null;
    onConfirm: (confirmData: ConfirmData) => void;
    onClose: () => void;
}

const useStyles = makeStyles({
    root: {
        maxWidth: "100%",
        flexGrow: 1,
    },
});

const TermosDeAceite: FC<TermosDeAceiteProperties> = ({
    open,
    tipo,
    codigoPedido,
    termosFinancieras,
    onConfirm,
    onClose
}) => {

    const classes = useStyles();
    const theme = useTheme();

    const [termosPedido, setTermosPedido] = useState<TermosAceiteList>({});
    const [dataPrevisaoFaturamento, setDataPrevisaoFaturamento] = useState<string | null>(null)
    const [estabelecimento, setEstabelecimento] = useState<number | null>(null)
    const [activeStep, setActiveStep] = useState(0);
    const [disableConfirmar, setDisablaConfirmar] = useState(true);

    const isValid = (): boolean => {
        let qtdObrigatorios: number = 0

        const keys = Object.keys(termosPedido)

        keys.forEach((key) => {
            const obrigatorios = termosPedido[Number(key)].filter((t) => t.opcional === false).length;
            qtdObrigatorios += obrigatorios
        })

        let qtdMarcadosObrigatorios: number = 0;

        keys.forEach((key) => {
            const obrigatoriosSelecionados = termosPedido[Number(key)].filter((t) => t.opcional !== true && t.aceito === true).length;
            qtdMarcadosObrigatorios += obrigatoriosSelecionados
        })

        return qtdMarcadosObrigatorios === qtdObrigatorios;
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const getTermosDeAceitePedido = async (): Promise<void> => {
        const result: IDataResponse<ResponseTermoAceitePedido | null> = await termoDeAceiteProvider.fetchTermosAceitePedido(codigoPedido)

        if (result.statusCode === STATUS_CODE.OK) {
            if (result.data) {
                const list: any = {}
                setDataPrevisaoFaturamento(result.data.data_previsao_faturamento)
                setEstabelecimento(result.data.estabelecimento_faturamento)
                for (const termo of result.data.termos) {
                    const index: number = TIPO_TERMO_PEDIDO[termo.tipo];
                    if (list[index]?.length) {
                        list[index].push(termo)
                    } else {
                        list[index] = [termo];
                    }
                }

                setTermosPedido(list)
            }
        }
    }

    const getTermosDeAceiteFinanceiras = async (): Promise<void> => {
        const listaTermosFinanceiras: ResponseTermoAceiteFinanceiras[] = termosFinancieras || []

        const list: any = {}
        for (const termo of listaTermosFinanceiras as any) {
            const index: number = termo.financeira_id || 0;
            if (termo.termos.length) {
                list[index] = termo.termos;
            }
        }

        setTermosPedido(list)
    }

    const handleConfirmar = () => {
        const listTermos: ITermoAceite[] = [];
        const keys = Object.keys(termosPedido);

        keys.forEach((key) => {
            termosPedido[Number(key)].forEach((t) => {
                listTermos.push(t)
            })
        })

        const confirmData: ConfirmData = {
            termos: listTermos,
        }

        if (tipo === TTIPO_TERMO_ACEITE.PEDIDO && dataPrevisaoFaturamento && estabelecimento) {
            confirmData.data_previsao_faturamento = dataPrevisaoFaturamento
            confirmData.estabelecimento = estabelecimento
        }

        onConfirm(confirmData)
    }


    const renderTitulo = (): ReactNode => {

        if (tipo === TTIPO_TERMO_ACEITE.FINANCEIRAS) {
            const financeirasCache = LocalStorage.get<CacheType<FinanceiraType[]> | null>("solar.financeiras", true);
            const financieraId = Number(Object.keys(termosPedido)[activeStep]);
            const financeira = financeirasCache?.data?.find((f) => f.id === financieraId);
            return `Termos & Condições${financeira ? " - " + financeira.nome : ""}`
        }

        if (tipo === TTIPO_TERMO_ACEITE.PEDIDO && Number(Object.keys(termosPedido)[activeStep]) === 1) {
            return "Termos & Condições - Faturamento"
        }

        return "Termos & Condições";
    }

    useEffect(() => {
        if (open) {
            tipo !== TTIPO_TERMO_ACEITE.FINANCEIRAS ? getTermosDeAceitePedido() : getTermosDeAceiteFinanceiras()
            setActiveStep(0)
        }
        if (!open) {
            setTermosPedido({})
        }
    }, [open])

    useEffect(() => {
        setDisablaConfirmar(!isValid())
    }, [termosPedido])

    return <>
        {Object.keys(termosPedido).length > 0 && <Dialog open={open} maxWidth={"md"} className="TermosDeAceite">
            <DialogTitle>
                <strong style={{ color: theme.palette.grey[500] }}>{renderTitulo()}</strong>
                <div className="close-button">
                    <IconButton
                        onClick={() => {
                            onClose()
                        }}
                    >
                        <MdClose />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="container">
                    <div className="row">
                        {Object.keys(termosPedido).length === 0 && <div className="X12">
                            <div className="loader-container">
                                <CircularProgress />
                            </div>
                        </div>}

                        <div className="X12">
                            {Object.keys(termosPedido).length > 0 && <>
                                {termosPedido[Number(Object.keys(termosPedido)[activeStep])]?.map((_termo, index) => {
                                    return <TermoAceite
                                        key={`termo-aceite-${_termo.id}-${index}`}
                                        termo={_termo}
                                        onChange={(newValue) => {
                                            const termosState = { ...termosPedido }
                                            const idxTermo = Number(Object.keys(termosPedido)[activeStep])
                                            termosState[idxTermo][index].aceito = newValue
                                            if (tipo === TTIPO_TERMO_ACEITE.FINANCEIRAS) {
                                                termosState[idxTermo][index].financeira_id = idxTermo
                                            }
                                            setTermosPedido(termosState)
                                        }}
                                    />
                                })}
                            </>}
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <MobileStepper
                    variant="progress"
                    steps={Object.keys(termosPedido).length}
                    position="static"
                    activeStep={Number(Object.keys(termosPedido)[activeStep])}
                    className={classes.root}
                    nextButton={<>
                        {Object.keys(termosPedido).length === (activeStep + 1) ? (
                            <Button
                                size="small"
                                disabled={disableConfirmar}
                                onClick={handleConfirmar}
                                variant="contained"
                                disableElevation
                                color="primary"
                                style={{ marginLeft: "17px" }}
                            >
                                Confirmar
                                {disableConfirmar ? <MdOutlineErrorOutline style={{ marginLeft: "7px" }} /> : <FaCheck style={{ marginLeft: "7px" }} />}
                            </Button>
                        ) : (
                            <Button size="small" onClick={handleNext} style={{ marginLeft: "17px" }}>
                                Próximo
                                <KeyboardArrowRight />
                            </Button>
                        )}
                    </>}
                    backButton={
                        <Button size="small" onClick={handleBack} disabled={activeStep === 0} style={{ marginRight: "17px" }}>
                            <KeyboardArrowLeft />
                            Anterior
                        </Button>
                    }
                />
            </DialogActions>
        </Dialog>}

        
    </>
}

export { TermosDeAceite }